import { createContext } from 'react';
import type { UiTone } from '@/theme/uiTokens';
import type { ReactNode } from 'react';

export type NotificationContextValue = {
  notify: (toast: { message: ReactNode; tone?: UiTone; timeoutMs?: number }) => void;
};

const noop: NotificationContextValue = {
  notify: () => {
    /* noop */
  },
};

export const NotificationContext = createContext<NotificationContextValue>(noop);
